var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-profile-card flex align--center" }, [
    _c("div", { staticClass: "photo" }, [
      _c("img", { attrs: { src: _vm.photoSource } }),
    ]),
    _c("h5", { staticClass: "name" }, [_vm._v(_vm._s(_vm.name))]),
    _c("span", { staticClass: "location" }, [
      _c("span", { staticClass: "icon glyphicon glyphicon-map-marker" }),
      _vm._v(" " + _vm._s(_vm.location)),
    ]),
    _c("div", { staticClass: "social" }, [
      _vm.social.facebook
        ? _c("a", {
            staticClass: "icon brandico brandico-facebook-rect",
            attrs: { href: "https://" + _vm.social.facebook, target: "_blank" },
          })
        : _vm._e(),
      _vm.social.instagram
        ? _c("a", {
            staticClass: "icon brandico brandico-instagram",
            attrs: {
              href: "https://" + _vm.social.instagram,
              target: "_blank",
            },
          })
        : _vm._e(),
      _vm.social.twitter
        ? _c("a", {
            staticClass: "icon brandico brandico-twitter",
            attrs: { href: "https://" + _vm.social.twitter, target: "_blank" },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }